import {combineReducers} from '@reduxjs/toolkit';

import {assignProductUserEntitlementsStateSlice} from './slices/assign-product-user-entitlements-state.slice';
import {assignProductUserEntitlementsSlice} from './slices/assign-product-user-entitlements.slice';

export const assignProductUserEntitlementsReducer = combineReducers({
    result: assignProductUserEntitlementsSlice.reducer,
    state: assignProductUserEntitlementsStateSlice.reducer,
});
